import Close from "@material-ui/icons/Close";
import Save from "@mui/icons-material/Save";
import { IconButton, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  GeneralContainer,
  IconContainer,
} from "./CreateInstantMessages.styled";

const CreateInstantMessages = ({ close, save, editData }) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    if (editData) {
      setValue(editData?.message);
    }
  }, [editData]);

  return (
    <GeneralContainer>
      <div style={{ padding: "10px" }} className="header-icon">
        <label className="header-label">Add instant message</label>
        <IconContainer>
          <Tooltip title="Save">
            <IconButton onClick={() => save(value)}>
              <Save />
            </IconButton>
          </Tooltip>
          <Tooltip title="Close">
            <IconButton onClick={() => close(false)}>
              <Close />
            </IconButton>
          </Tooltip>
        </IconContainer>
      </div>
      <input
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
    </GeneralContainer>
  );
};

export default CreateInstantMessages;
